import Button, { Popconfirm, IconButton } from "./Button";
Button.Popconfirm = Popconfirm;
Button.IconButton = IconButton;
export default Button;